import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Link from "next/link";
import {
  Box,
  Button,
  Card,
  Checkbox,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Heading,
  Input,
  Radio,
  RadioGroup,
  Stack,
  Text,
} from "@chakra-ui/react";
import { sendOTP } from "./api/authenticate.js";
import Swal from "sweetalert2";
import { validate } from "email-validator"; // Import email-validator library or use any other email validation method
import Chatbot from "./customerservicesbot";
import axios from "axios";
import url from "../config/config.json";
import api from "../config/axios";
import { getCompanyLogoByCompanyId } from "./api/recruiter";
import { useLoginData } from "../context/context";

export default function RegisterPage() {
  const DEFAULT_COMPANY_ID = 100;
  const router = useRouter();
  const { setWhiteLabel } = useLoginData();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [userRole, setUserRole] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [isVerifyEmailDisabled, setIsVerifyEmailDisabled] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [existingEmailError, setExistingEmailError] = useState("");
  const [existingMobileError, setExistingMobileError] = useState("");
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isSendingOTP, setIsSendingOTP] = useState(false);
  const [consentChecked, setConsentChecked] = useState(false);
  const [companyId, setCompanyId] = useState(DEFAULT_COMPANY_ID);

  //new changes
  const [logresponse, setLogResponse] = useState(null);

  const [errorResponse, setErrorResponse] = useState(null);

  const [useriddata, setUserIdData] = useState(null);

  const [usertypedata, setUserTypeData] = useState(null);

  const submitSignUp = async ({
    firstName,
    lastName,
    email,
    mobile,
    userRole,
    otp,
    companyId,
  }) => {
    try {
      const response = await api.post("/signup", {
        username: `${firstName} ${lastName}`,
        email,
        mobile,
        user_role: userRole,
        otp,
        company_id: companyId || DEFAULT_COMPANY_ID,
      });

      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        if (error.response.data === "OTP incorrect") {
          return {
            signup: "OTP incorrect",
            message: "Incorrect OTP, Please try again.",
          };
        }

        return {
          signup: "user_exists",
          message: error.response.data.message,
        };
      }

      throw error;
    }
  };

  const normalizeCompanyName = (value = "") =>
    decodeURIComponent(value)
      .replace(/\+/g, " ")
      .replace(/[-_]/g, " ")
      .trim()
      .replace(/\s+/g, " ")
      .toLowerCase();

  const getSignupSlugFromRoute = () => {
    const pathnameWithoutQuery = (router.asPath || "").split("?")[0];
    const pathSegments = pathnameWithoutQuery.split("/").filter(Boolean);
    const rawPathCompanyName =
      pathSegments.length > 1 &&
      pathSegments[0].toLowerCase() === "signup"
        ? pathSegments[1]
        : "";

    return (
      rawPathCompanyName ||
      (Array.isArray(router.query.companySlug)
        ? router.query.companySlug[0]
        : router.query.companySlug) ||
      (Array.isArray(router.query.companyName)
        ? router.query.companyName[0]
        : router.query.companyName) ||
      ""
    );
  };

  const isCandidateOnlySignup = Boolean(
    router.isReady && getSignupSlugFromRoute()
  );

  useEffect(() => {
    if (!router.isReady) return;

    if (isCandidateOnlySignup) {
      setUserRole("candidate");
    }
  }, [router.isReady, isCandidateOnlySignup]);

  useEffect(() => {
    if (!router.isReady) return;

    const rawCompanyName = getSignupSlugFromRoute();
    let createdLogoUrl = null;

    const isWhiteLabelled = (value) =>
      String(value ?? "").trim().toUpperCase() === "TRUE";

    const applyWhiteLabel = async (matchedCompany) => {
      if (!matchedCompany || !isWhiteLabelled(matchedCompany.white_labelling)) {
        setWhiteLabel(null);
        return;
      }

      try {
        const logoBlob = await getCompanyLogoByCompanyId(
          matchedCompany.company_id
        );
        createdLogoUrl = URL.createObjectURL(logoBlob);
        setWhiteLabel({
          logoUrl: createdLogoUrl,
          companyName: matchedCompany.company_name || "",
        });
      } catch (error) {
        console.error("Failed to fetch company logo:", error);
        // Still hide our branding even if the logo could not be loaded.
        setWhiteLabel({
          logoUrl: null,
          companyName: matchedCompany.company_name || "",
        });
      }
    };

    const fetchCompanies = async () => {
      try {
        const response = await api.get("/get_all_companies");
        const companies = Array.isArray(response?.data?.companies)
          ? response.data.companies
          : [];

        if (!rawCompanyName) {
          setCompanyId(DEFAULT_COMPANY_ID);
          setWhiteLabel(null);
          return;
        }

        const resolvedCompanyName = normalizeCompanyName(rawCompanyName);
        const matchedCompany = companies.find(
          (company) =>
            normalizeCompanyName(company?.company_name || "") ===
            resolvedCompanyName
        );

        setCompanyId(matchedCompany?.company_id || DEFAULT_COMPANY_ID);
        await applyWhiteLabel(matchedCompany);
      } catch (error) {
        console.error("Failed to fetch companies:", error);
        setCompanyId(DEFAULT_COMPANY_ID);
        setWhiteLabel(null);
      }
    };

    fetchCompanies();

    return () => {
      setWhiteLabel(null);
      if (createdLogoUrl) URL.revokeObjectURL(createdLogoUrl);
    };
  }, [
    router.isReady,
    router.asPath,
    router.query.companySlug,
    router.query.companyName,
  ]);

  const handleSendOTP = async () => {
    try {
      setIsSendingOTP(true); // Set the loading state
      setIsVerifyEmailDisabled(true);

      if (!validate(email)) {
        setEmailError("Please enter a valid email id.");
        setIsSendingOTP(false); // Reset the loading state
        return;
      }

      console.log(email);
      const result = await sendOTP(email);
      setOtpSent(true);
      setIsVerifyEmailDisabled(false);
      setIsSendingOTP(false); // Reset the loading state
    } catch (error) {
      setIsVerifyEmailDisabled(false);
      console.log(error);
    }
  };

  // mobile number validate
  const handleMobileChange = (e) => {
    const enteredMobile = e.target.value.replace(/\D/g, ""); // Remove non-digit characters

    if (enteredMobile.length > 10) {
      setMobile(enteredMobile.slice(0, 10)); // Only take the first 10 digits
    } else {
      setMobile(enteredMobile);
    }
  };

  const validateCompanyEmail = (email) => {
    // List of personal email domains to block
    const personalDomains = [
      "gmail.com",
      "yahoo.com",
      "hotmail.com",
      "outlook.com",
      "icloud.com",
      "protonmail.com",
      "aol.com",
      "mail.com",
      "zoho.com",
      "live.com",
      "msn.com",
    ];

    // Extract domain from email
    const emailDomain = email.split("@")[1].toLowerCase();

    // Check if user role is company (recruiter)
    if (userRole === "recruiter") {
      // Block personal domains for company role
      if (personalDomains.includes(emailDomain)) {
        return "Please use a company email address";
      }
    }

    return ""; // No error
  };

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);
      setIsFormSubmitted(true);

      if (!consentChecked) {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please consent to the Privacy Policy to continue",
          showConfirmButton: false,
          timer: 2000,
        });
        setIsSubmitting(false);
        return;
      }

      // Validate company email for recruiter
      if (userRole === "recruiter") {
        // List of personal email domains to block
        const personalDomains = [
          "gmail.com",
          "yahoo.com",
          "hotmail.com",
          "outlook.com",
          "icloud.com",
          "protonmail.com",
          "aol.com",
          "mail.com",
          "zoho.com",
          "live.com",
          "msn.com",
        ];

        // Extract domain from email
        const emailDomain = email.split("@")[1].toLowerCase();

        // Block personal domains for company role
        if (personalDomains.includes(emailDomain)) {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Please use a company email address",
            showConfirmButton: false,
            timer: 1500,
          });
          setIsSubmitting(false);
          return;
        }
      }

      // Validate mobile number
      const mobileRegex = /^\d{10}$/;
      if (mobile.length !== 10 || !mobileRegex.test(mobile)) {
        setIsSubmitting(false);
        setMobileError("Mobile number should be 10 digits");
        return;
      }

      // Reset mobile error if valid
      setMobileError("");

      const result = await submitSignUp({
        firstName,
        lastName,
        email,
        mobile,
        userRole,
        otp,
        companyId,
      });
      setIsSubmitting(false);
      console.log(result);

      if (result && result.signup === "success") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Registration successful!",
          showConfirmButton: false,
          timer: 1500,
        });
        router.push("/login");

        // calling log action
        <div>
          {logresponse
            ? console.log(<pre>{JSON.stringify(logresponse, null, 2)}</pre>)
            : console.log(<p>Error</p>)}
        </div>;
      } else if (result && result.signup === "OTP incorrect") {
        // Handle incorrect OTP scenario
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Incorrect OTP,Please try again!",
          showConfirmButton: false,
          timer: 1500,
        });

        // calling log action
        <div>
          {errorResponse
            ? console.log(<pre>{JSON.stringify(errorResponse, null, 2)}</pre>)
            : console.log(<p>Error</p>)}
        </div>;
      } else if (result && result.signup === "user_exists") {
        const errorMessage =
          result && result.message
            ? result.message
            : "Email id already exists, please Login";
        // Display an error message or handle the existing user scenario
        // alert(errorMessage);
        Swal.fire({
          // title: errorMessage,
          position: "center",
          icon: "error",
          title: errorMessage,
          showConfirmButton: false,
          timer: 1500,
        });

        // calling log action
        <div>
          {errorResponse
            ? console.log(<pre>{JSON.stringify(errorResponse, null, 2)}</pre>)
            : console.log(<p>Error</p>)}
        </div>;
      } else {
        // Handle other error scenarios
        const errorMessage = "An error occurred during sign up.";
        // Display an error message or handle the error scenario
        // alert(errorMessage);
        Swal.fire({
          position: "center",
          icon: "error",
          title: errorMessage,
          showConfirmButton: false,
          timer: 1500,
        });

        // calling log action
        <div>
          {errorResponse
            ? console.log(<pre>{JSON.stringify(errorResponse, null, 2)}</pre>)
            : console.log(<p>Error</p>)}
        </div>;
      }

      // window.location.reload();
    } catch (error) {
      setIsSubmitting(false);
      console.log(error);

      // calling log action
      <div>
        {errorResponse
          ? console.log(<pre>{JSON.stringify(errorResponse, null, 2)}</pre>)
          : console.log(<p>Loading...</p>)}
      </div>;
    }
  };

  //new changes [Log Action]
  useEffect(() => {
    const fetchData = async () => {
      try {
        const baseUrl = url.baseUrl;
        const logActionUrl = `${baseUrl}/log_action`;

        const useriddata = JSON.parse(sessionStorage.getItem("userId"));
        setUserIdData(useriddata);

        const usertypedata = JSON.parse(sessionStorage.getItem("userType"));
        setUserTypeData(usertypedata);

        const formData = [
          { key: "id_type", value: usertypedata },
          { key: "id", value: useriddata },
          { key: "action", value: "SignUp Successfully" },
        ];

        // Convert formData to x-www-form-urlencoded format
        const data = new URLSearchParams();
        formData.forEach(({ key, value }) => {
          data.append(key, value);
        });

        // Make the POST request
        const consoleresponse = await axios.post(logActionUrl, data);
        setLogResponse(consoleresponse.data);
      } catch (error) {
        console.error("Error:", error.message);

        // If there's an error, update the action to "Error in login"
        const formDataError = [
          { key: "id_type", value: usertypedata },
          { key: "id", value: useriddata },
          { key: "action", value: "Error in Signup" },
        ];

        // Convert formDataError to x-www-form-urlencoded format
        const dataError = new URLSearchParams();
        formDataError.forEach(({ key, value }) => {
          dataError.append(key, value);
        });

        // Make another POST request to log the error
        const errorResponse = await axios.post(logActionUrl, dataError);
        setErrorResponse(errorResponse.data);
      }
    };

    fetchData();
  }, []);

  return (
    <Box maxWidth="400px" margin="0 auto" marginTop="30px">
      <Card padding="1rem">
        <Heading as="h2" textAlign="center" marginBottom="2rem" color="#4299e1">
          SignUp
        </Heading>

        <FormControl
          isRequired
          marginBottom="1rem"
          isInvalid={!firstName && isFormSubmitted}
        >
          <FormLabel>First Name</FormLabel>
          <Input
            type="text"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
          {!firstName && isFormSubmitted && (
            <FormErrorMessage>First Name is required</FormErrorMessage>
          )}
        </FormControl>

        <FormControl
          isRequired
          marginBottom="1rem"
          isInvalid={!lastName && isFormSubmitted}
        >
          <FormLabel>Last Name</FormLabel>
          <Input
            type="text"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
          {!lastName && isFormSubmitted && (
            <FormErrorMessage>Last Name is required</FormErrorMessage>
          )}
        </FormControl>

        <FormControl
          isRequired
          marginBottom="1rem"
          isInvalid={!email && isFormSubmitted}
        >
          <FormLabel>Email</FormLabel>
          <Stack direction="row">
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={otpSent}
            />
            {!otpSent && (
              <Button
                colorScheme="blue"
                isLoading={isSendingOTP}
                loadingText="Sending OTP..."
                onClick={handleSendOTP}
                disabled={isSendingOTP || otpSent}
              >
                Send OTP
              </Button>
            )}
          </Stack>
          {otpSent && (
            <Text fontSize="sm" marginTop="0.5rem" color="gray.500">
              OTP sent to your email. Please enter the OTP below.
            </Text>
          )}
          {!email && isFormSubmitted && (
            <FormErrorMessage>Email is required</FormErrorMessage>
          )}
          {emailError && <div style={{ color: "red" }}>{emailError}</div>}
        </FormControl>

        {otpSent && (
          <FormControl
            isRequired
            marginBottom="1rem"
            isInvalid={!otp && isFormSubmitted}
          >
            <FormLabel>OTP</FormLabel>
            <Input
              type="text"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
            {!otp && isFormSubmitted && (
              <FormErrorMessage>OTP is required</FormErrorMessage>
            )}
          </FormControl>
        )}

        <FormControl
          isRequired
          marginBottom="1rem"
          isInvalid={!mobile && isFormSubmitted}
        >
          <FormLabel>Mobile</FormLabel>
          <Input
            type="tel"
            value={mobile}
            // onChange={(e) => setMobile(e.target.value)}
            onChange={handleMobileChange}
          />
          {!mobile && isFormSubmitted && (
            <FormErrorMessage>Mobile is required</FormErrorMessage>
          )}
          {mobileError && (
            <div
              style={{ color: "red" }}
              dangerouslySetInnerHTML={{ __html: mobileError }}
            />
          )}
        </FormControl>

        <FormControl
          isRequired
          marginBottom="1rem"
          isInvalid={!userRole && isFormSubmitted}
        >
          <FormLabel>Role</FormLabel>
          <RadioGroup value={userRole} onChange={(value) => setUserRole(value)}>
            <Stack direction="row">
              <Radio value="candidate">Candidate</Radio>
              {!isCandidateOnlySignup && (
                <Radio value="recruiter">Company</Radio>
              )}
            </Stack>
          </RadioGroup>
          {!userRole && isFormSubmitted && (
            <FormErrorMessage>Role is required</FormErrorMessage>
          )}
        </FormControl>

        <FormControl marginBottom="1rem" isInvalid={!consentChecked && isFormSubmitted}>
          <Checkbox
            isChecked={consentChecked}
            onChange={(e) => setConsentChecked(e.target.checked)}
          >
            <Text fontSize="sm">
              I consent to the collection, processing, and storage of my personal
              information for recruitment and evaluation purposes, as per the
              Privacy Policy.
            </Text>
          </Checkbox>
          {!consentChecked && isFormSubmitted && (
            <FormErrorMessage>You must consent to continue</FormErrorMessage>
          )}
        </FormControl>

        <Button
          colorScheme="blue"
          isLoading={isSubmitting}
          loadingText="Submitting"
          onClick={handleSubmit}
          marginBottom="1rem"
          isDisabled={!consentChecked}
        >
          SignUp
        </Button>

        <Chatbot />
        <Text>
          Have you already Signed Up?{" "}
          {/* <div>
      {logresponse ? (
        <pre>{JSON.stringify(logresponse, null, 2)}</pre>
      ) : (
        <p>Loading...</p>
      )}
    </div> */}
          <Link href="/login">
            <span>Login</span>
          </Link>
        </Text>
      </Card>
    </Box>
  );
}
